import { Link } from 'react-router-dom'

const NotFound = () => (
  <main className="min-h-screen flex items-center">
    <div className="max-w-6xl mx-auto px-5 sm:px-8 w-full">
      <h1 className="font-serif text-5xl sm:text-7xl font-medium tracking-tight">Page not found</h1>
      <p className="mt-6 text-lg text-mute max-w-prose">
        This address does not lead anywhere. Go back to the portfolio to see my work.
      </p>
      <Link to="/" className="mt-8 inline-block font-medium text-accent underline underline-offset-4 hover:no-underline">
        Back to the portfolio
      </Link>
    </div>
  </main>
)

export default NotFound
